/* eslint-disable no-unused-vars */
import request from "../request";
import { AUTH_STORAGE_KEY } from "@/config.js";

const headers = () => {
  return {
    Authorization: `Bearer ${
      JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY)).token
    }`,
    "Cache-Control": "no-cache",
  };
};

const buildParams = (payload) => {
  return [
    `client=${payload?.client ? payload?.client : ""}`,
    `only_with_request=${payload?.only_with_request ? 1 : 0}`,
    `from=${payload?.from ? payload?.from : ""}`,
    `to=${payload?.to ? payload?.to : ""}`,
    `user=${payload?.user ? payload?.user : ""}`,
    `spent=${payload?.spent ? payload?.spent : ""}`,
    `itinerary=${payload?.itinerary ? payload?.itinerary : ""}`,
    `service=${payload?.service ? payload?.service : ""}`,
  ].join("&");
};

export default {
  getQuotesByTime(payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/periodic-quotes?${buildParams(payload)}`,
      headers: headers(),
    });
  },
  getQuotesByClients(payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/clients?${buildParams(payload)}`,
      headers: headers(),
    });
  },
  loadUserSummary() {
    return request({
      method: "GET",
      url: `/tenant/reports/summary`,
      headers: headers(),
    });
  },
  getRequestsByStages(payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/stages?${buildParams(payload)}`,
      headers: headers(),
    });
  },
  loadQuotesByDestinations(payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/destinations?${buildParams(payload)}`,
      headers: headers(),
    });
  },
  loadReport(type, payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/${type}?${buildParams(payload)}`,
      headers: headers(),
    });
  },
  loadConversions(payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/conversions?${buildParams(payload)}`,
      headers: headers(),
    });
  },
  loadQuotes(payload) {
    return request({
      method: "GET",
      url: `/tenant/reports/quotes?${buildParams(payload)}`,
      headers: headers(),
    });
  },
};
